const STATUS_TONE: Record<string, string> = {
  closed: 'bg-emerald-50 text-emerald-700', noise: 'bg-slate-100 text-slate-600',
  failed: 'bg-rose-50 text-rose-700', interrupted: 'bg-amber-50 text-amber-700',
  autofix_running: 'bg-blue-50 text-blue-700', pr_ready: 'bg-violet-50 text-violet-700',
  needs_human: 'bg-orange-50 text-orange-700', open: 'bg-cyan-50 text-cyan-700',
};

export function TicketBadge({ value }: { value: string | null }): React.JSX.Element {
  const text = value ?? '-';
  return <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${STATUS_TONE[text] ?? 'bg-line-soft text-muted'}`}>{text}</span>;
}
